var noop = function noop() {};
var noopHook = function noopHook() {
  return [];
};
export { noop, noopHook };